import { PiDotsThree } from "react-icons/pi";

import { EditableRadio } from "@/components/2/editable-radio";
import { useGetAgenciesGeographiesAgenciesGet } from "@/services/2/react-query/hooks";

type AgencySelectorProps = {
  legalEntity: string;
  selectedAgency: string | null;
  onChange?: (agencyUuid: string | null) => void;
};
export const AgencySelector = ({ legalEntity, selectedAgency, onChange }: AgencySelectorProps) => {
  const { data: agencies } = useGetAgenciesGeographiesAgenciesGet(
    {
      query: { legal_entity_uuids: [legalEntity] },
    },
    [legalEntity],
    {
      staleTime: 60 * 60 * 1000, // 1 hour
    }
  );

  if (!agencies) {
    return <p>Chargement...</p>;
  }

  const sortedAgencies = agencies.sort((a, b) => a.agency_name.localeCompare(b.agency_name));

  // If read-only, just display the agency name
  if (!onChange) {
    const currentAgency = sortedAgencies.find(agency => agency.agency_uuid === selectedAgency);
    return (
      <div style={{ minHeight: "24px", padding: "2px", opacity: 0.7 }}>
        {currentAgency?.agency_name || "-"}
      </div>
    );
  }

  return (
    <EditableRadio
      name="agencies"
      value={selectedAgency}
      onChangeValue={onChange}
      options={sortedAgencies.map(agency => ({
        value: agency.agency_uuid,
        label: agency.agency_name,
      }))}
      allowUnselect={true}
      toggleIcon={selectedAgency ? <PiDotsThree /> : undefined}
    />
  );
};
